module.exports = __webpack_public_path__ + "media/images/icon__warning@2x-d96328c0fc0a9c6f6043ded2e4f90e48.png";